import {
  FaBroadcastTower,
  FaChartArea,
  FaCheck,
  FaChartBar,
  FaCoins,
  FaDesktop,
  FaHdd,
  FaMoneyCheck,
  FaNetworkWired,
  FaServer,
  FaSignal,
  FaUser,
} from "@onemind-services-llc/react-icons-ng/fa";

import CmlWorkstation from "public/managed-colocation/cml-workstation.webp";
import CmlCloudHosting from "public/managed-colocation/cml-cloud-hosting.webp";
import CmlCloudSecurity from "public/managed-colocation/cml-cloud-security.webp";
import CmlNetworkHub from "public/managed-colocation/cml-network-hub.webp";

export const MANAGED_COLOCATION_CONSTANTS = {
  MANAGED_COLOCATION: "Managed Colocation",
  MANAGED_COLOCATION_DESC:
    "CloudMyLab offers a managed colocation solution for our customers with our state-of-the-art technology suite and remote hands.  Our services are available in all Cologix and Hurricane Electric Data-Center across the country. ",
  GETTING_STARTED: "Getting Started Is Incredibly Simple",
  WHY_COLOCATION: "Why Managed Colocations?",
  PRICING_OPTIONS: "Pricing Options",
};

export const LIST = [
  {
    content:
      "We will get you any size Rack you need starting from a Quarter Rack to a suite of racks",
    icon: FaServer,
  },
  {
    content: "L2 Connectivity to your Hub site or Multisite connections",
    icon: FaBroadcastTower,
  },
  { content: "Mobile Private IP with Verizon and ATT", icon: FaDesktop },
  { content: "Rack stack/ Cabling Services", icon: FaNetworkWired },
  {
    content: "Hardware Procurement services/ Hardware Leasing options",
    icon: FaMoneyCheck,
  },
  { content: "NOC services", icon: FaChartArea },
  { content: "1:1 Instance with Zero Downtime ", icon: FaChartBar },
  {
    content:
      "Multiple input power options available from 120V-15A to single-phase to three-phase 240V-60A per Rack with redundancy options ",
    icon: FaHdd,
  },
  { content: "Internet connectivity options from 250mbps to 10G", icon: FaSignal },
  { content: "Multiple Carrier options", icon: FaCheck },
  { content: "Transit to 140 POPs across ", icon: FaCoins },
  { content: "Onsite Tech Services", icon: FaUser },
];

export const MANAGED_COLOCATION_FEATURES_LIST = [
  {
    content: "Saves you time and money to manage your Datacenter",
    image: CmlWorkstation,
    title: "Lean IT",
  },
  {
    content: "Least cost intensive model and you still save cost on Public Cloud",
    image: CmlCloudHosting,
    title: "Opex Model",
  },
  {
    content: "State of the Art Security for your datacenter ",
    image: CmlCloudSecurity,
    title: "Security",
  },
  {
    content: "Class apart support with Aggressive SLAs, we answer your call 24/7 ",
    image: CmlNetworkHub,
    title: "Support",
  },
];
